import React, { useState, useReducer, useEffect } from 'react';
import {
  Paper,
  Chip,
  Box,
} from '@mui/material';
import {
  VirtualTableState,
  SortingState,
  DataTypeProvider,
  FilteringState,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableColumnResizing,
  TableFilterRow,
} from '@devexpress/dx-react-grid-material-ui';
import DateRange from '@mui/icons-material/DateRange';
import TimeAgo from 'react-timeago'

import utils from '../utils'
import AuthService from '../services/auth-service';
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import Badge from '@mui/material/Badge';
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";

import ComputerListTableProps, { AccessoWebTypeProvider, DateTypeProvider, IsAdminTypeProvider, IsResellerTypeProvider, KeygenTypeProvider, PasswordHashTypeProvider, SwNameTypeProvider, ResellerUsernameTypeProvider, RowNumTypeProvider, UserCodeTypeProvider, UsernameTypeProvider, SwVerTypeProvider, BuildLicFormatter, ViewLicTypeProvider, AutoLicFormatter, ViewLicFormatter, LicOptionsFormatter, UserTypeTypeProvider } from './computer_list/ComputerListTableProps'
import { GeoTypeProvider } from './ServiceUserListTableProps'
import ComputerListAddNewFormDialog from './computer_list/ComputerListAddNewFormDialog'
import ComputerListDeleteFormDialog from './computer_list/ComputerListDeleteFormDialog'
import notify from 'devextreme/ui/notify';

import AddIcon from '@mui/icons-material/Add';
import AddBoxIcon from '@mui/icons-material/AddBox';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import NavigationIcon from '@mui/icons-material/Navigation';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Fab from '@mui/material/Fab';

// ************************************************************
// ************************************************************
// ************************************************************

const VIRTUAL_PAGE_SIZE = 50;

function intToIP(int) {
  var part1 = int & 255
  var part2 = ((int >> 8) & 255)
  var part3 = ((int >> 16) & 255)
  var part4 = ((int >> 24) & 255)
  return part4 + "." + part3 + "." + part2 + "." + part1
}

// ************************************************************
// ************************************************************
// ************************************************************

export const ComputerListComponentWrapper = (props) => {
  const { reseller_id, user_id, user_code, selector, gasspecialists } = useParams()
  const navigate = useNavigate()
  return <ComputerList 
    gasspecialists={gasspecialists}
    reseller_id={reseller_id} 
    user_id={user_id} 
    user_code={user_code} 
    selector={selector} 
    navigate={navigate} 
    {...props} />
}

// Funzione per gestire il filtro della colonna "user type"
const handleUserTypeFilter = (filters) => {
  const newFilters = [];
  let userTypeFilterValue = null;
  
  // Estrarre il valore del filtro 'u_user_type' e processare gli altri filtri
  filters.forEach(filter => {
    if (filter.columnName === 'u_user_type') {
      newFilters.push(filter);
      userTypeFilterValue = filter.value.toLowerCase();
      // Non aggiungiamo questo filtro direttamente a newFilters
    } else if (
      filter.columnName !== 'u_is_admin' &&
      filter.columnName !== 'u_is_reseller' &&
      filter.columnName !== 'u_is_gas_specialist'
    ) {
      // Aggiungiamo gli altri filtri a newFilters
      newFilters.push(filter);
    }
    // Altrimenti, non aggiungiamo i filtri 'u_is_admin', 'u_is_reseller', 'u_is_gas_specialist' esistenti
  });

  // Basandoci su userTypeFilterValue, aggiungiamo o rimuoviamo i filtri appropriati
  if (userTypeFilterValue !== null) {
    if (userTypeFilterValue.includes('a')) {
      newFilters.push({ columnName: 'u_is_admin', value: 1, operation: 'equal' });
    }
    if (userTypeFilterValue.includes('r')) {
      newFilters.push({ columnName: 'u_is_reseller', value: 1, operation: 'equal' });
    }
    if (userTypeFilterValue.includes('g')) {
      newFilters.push({ columnName: 'u_is_gas_specialist', value: 1, operation: 'equal' });
    }
    // Se una lettera non è inclusa, non aggiungiamo il filtro corrispondente, quindi viene rimosso
  }

  ///console.log("newFilters", newFilters);
  return newFilters;
};

class ComputerList extends React.Component {
  constructor(props) {    
    super(props)    
    this.table_props = new ComputerListTableProps()
    this.state = {
      current_gasspecialists: undefined,
      add_new_dialog_open: false,
      add_new_dialog_spin: false,
      delete_dialog_open: false,
      delete_dialog_spin: false,
      table_total_row_count_ready: false,
      tableRows: [],
      tableSkip: 0,
      requestedTableSkip: 0,
      requestedTableTake: 10,
      tableTotalRowCount: VIRTUAL_PAGE_SIZE * 2,
      tableLoading: false,      
      tableColumnWidths: this.table_props.getTableColumnWidths(null),
      tableFilters: [],
      tableSorting: [{
        columnName: "insert_date",
        direction: "desc",
      }],
      programList: [],
      resellersRows: [],
      currentResellerId: undefined,
      dataLoading: true,
    }
    // Variabili per memorizzare gli ID dei timeout
    this.filterTimeout = null;
    this.rowsTimeout = null;
    // Bind debounce wrapper
    this.debouncedGetTableRows = this.debouncedGetTableRows.bind(this);
  }  

  // Funzione debounce per getTableRows
  debouncedGetTableRows(requestedTableSkip, take) {
    if (this.rowsTimeout) {
      clearTimeout(this.rowsTimeout);
    }
    this.rowsTimeout = setTimeout(() => {
      this.getTableRows(requestedTableSkip, take);
    }, 800); // Ritardo di 800 millisecondi
  }

  tableRowsChanged() {
    this.getTableRows(
      this.state.requestedTableSkip,
      this.state.requestedTableTake
    )
  }  
  async getTableRows(requestedTableSkip, take) {
    this.setState({ 
      requestedTableSkip: requestedTableSkip,
      requestedTableTake: take,
    })
    this.setState({ tableLoading: true })
    AuthService.getComputerList(requestedTableSkip, take, this.state.tableSorting[0], this.state.tableFilters).then(data => {
      var i = requestedTableSkip + 1
      data.rows = data.rows.map(row => {
        row.row_num = i++
        //row.l_ip_addr = intToIP(row.l_ip_addr)
        row.build_lic = true
        row.view_lic = (row.lic_file !== '')
        row.u_user_type = "";
        row.u_user_type += row.u_is_admin ? "A" : "_";
        row.u_user_type += row.u_is_reseller ? "R" : "_";
        row.u_user_type += row.u_is_gas_specialist ? "G" : "_";        
        return row
      })
      if (data.is_valid) {
        this.setState({
          tableSkip: data.skip, 
          tableRows: data.rows,
          tableLoading: false,
        })
      } else {
        //console.log(data.message)
        this.setState({ tableLoading: false })
      }
    }).catch(e => {
      //console.log(e)
      this.setState({ tableLoading: false })
    })
  }
  async setTableFilters(value) {
    const newFilters = handleUserTypeFilter(value);
    this.setState({ tableFilters: newFilters });
    // Cancella il timeout precedente se esiste
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    // Imposta un nuovo timeout per il conteggio
    this.filterTimeout = setTimeout(async () => {
      var data = await AuthService.getComputerCount(newFilters);
      if (data.is_valid) {
        this.setState({
          tableTotalRowCount: data.value,
          table_total_row_count_ready: true,
        });
      }
    }, 800); // Ritardo di 800 millisecondi    
    // Debounce anche per la query dei dati
    this.debouncedGetTableRows(0, VIRTUAL_PAGE_SIZE);
  }
  async componentDidMount() {
    console.log("*** componentDidMount")
    console.log("reseller_id", this.props.reseller_id) 
    console.log("user_id", this.props.user_id) 
    console.log("user_code", this.props.user_code) 
    console.log("selector", this.props.selector) 
    console.log("gasspecialists", this.props.gasspecialists) 

    await this.setState({ current_gasspecialists: this.props.gasspecialists })

    var tableFilters = []
    if (this.props.gasspecialists !== undefined) {
      console.log("filtering for gasspecialists")
      tableFilters.push({
        columnName: "u_is_gas_specialist",
        value: "1",
        operation: "equal",
      })   
    } else if (this.props.reseller_id !== undefined) {
      var data = await AuthService.getServiceUserDetails(this.props.reseller_id)
      if (data.is_valid) {
        console.log("reseller_username contains " + data.user.username)
        tableFilters.push({
          columnName: "reseller_username",
          value: data.user.username,
          operation: "contains",
        })        
      }
    } else if (this.props.user_id !== undefined) {
      var data = await AuthService.getServiceUserDetails(this.props.user_id)
      if (data.is_valid) {
        console.log("username contains " + data.user.username)
        tableFilters.push({
          columnName: "u_username",
          value: data.user.username,
          operation: "contains",
        })        
      }
    } else if (this.props.user_code !== undefined) {
      console.log("user_code contains " + this.props.user_code)
      tableFilters.push({
        columnName: "user_code",
        value: this.props.user_code,
        operation: "contains",
      })              
    } else if (this.props.selector !== undefined) {
      tableFilters.push({
        columnName: "l_sw_name",
        value: this.props.selector,
        operation: "contains",
      })      
    }
    await this.setTableFilters(tableFilters)

    if (this.props.authStatus.completed) {
      await this.setState({ tableColumnWidths: this.table_props.getTableColumnWidths(this.props.authStatus.user) })
      await this.makeApiCalls()      
    }
  }
  async componentDidUpdate(prevProps) {
    console.log("*** componentDidUpdate")
    if (this.props.gasspecialists !== this.state.current_gasspecialists) {
      window.location.reload()
    } else if (!prevProps.authStatus.completed && this.props.authStatus.completed) {
      await this.setState({ tableColumnWidths: this.table_props.getTableColumnWidths(this.props.authStatus.user) })
      await this.makeApiCalls()      
    }
  }
  componentWillUnmount() {
    // Cancella i timeout quando il componente viene smontato
    if (this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }
    if (this.rowsTimeout) {
      clearTimeout(this.rowsTimeout);
    }
  }
  async makeApiCalls() {
    console.log("makeApiCalls start")
    
    if (this.props.authStatus.user.is_admin || this.props.authStatus.user.is_reseller) {
      var programList = await AuthService.getProgramList()
      //console.log("programList", programList)
      await this.setState({
        programList: programList
      }) 
    }

    if (this.props.authStatus.user.is_reseller) {      
      await this.setState({ 
        currentResellerId: this.props.authStatus.user.id 
      })          
    }
    if (this.props.authStatus.user.is_admin) {      
      var resellerData = await AuthService.getResellerList()
      if (resellerData.is_valid) {
        var i = 1
        var rows = await resellerData.rows.map(row => {
          row.row_num = i++
          row.view_text = `${row.company_name} (${row.company_country})`
          return row
        })
        //rows = [ rows[0] ] // tengo solo il primo
        //console.log(rows)
        // var reseller_id = (rows.length === 1) ? rows[0].id : undefined          
        // console.log("reseller_id", reseller_id)
        await this.setState({
          resellersRows: rows,
        })

        await rows.map(row => {
          if (row.username === "landi_renzo_italia") {
            this.setState({ currentResellerId: row.id })
          }
          return row
        })
      }
    }

    await this.setState({
      dataLoading: false,
    })
    console.log("makeApiCalls done")
  }


  
  handleComputerListAddNewDialog_ResellerIdChanged(e) { this.setState({ currentResellerId: e.target.value }) }
  handleComputerListAddNewFormDialog_ClickClose() { this.setState({ add_new_dialog_open: false }) }
  handleComputerListAddNewFormDialog_ClickSubmit(e) {
    // console.log(e)
    // return
    this.setState({ add_new_dialog_spin: true })
    AuthService.addComputer(e.user_code, e.username, this.state.currentResellerId).then(data => {
      if (data.is_valid) {
        // aggiorno la lista
        this.getTableRows(
          this.state.requestedTableSkip,
          this.state.requestedTableTake
        )
      } else {
        console.log(data.message)
        this.notifySomething(data.message, "error")
      }
      this.setState({ add_new_dialog_open: false, add_new_dialog_spin: false })
    }).catch(e => {
      console.log(e)
      this.notifySomething(e, "error")
      this.setState({ add_new_dialog_open: false, add_new_dialog_spin: false })
    })
  }

  handleComputerListDeleteFormDialog_ClickClose() { this.setState({ delete_dialog_open: false }) }
  handleComputerListDeleteFormDialog_ClickSubmit(e) {
    console.log(e)
    this.setState({ delete_dialog_spin: true })
    AuthService.deleteComputer(e).then(data => {
      if (data.is_valid) {
        // aggiorno la lista
        this.getTableRows(
          this.state.requestedTableSkip,
          this.state.requestedTableTake
        )
      } else {
        console.log(data.message)
        this.notifySomething(data.message, "error")
      }
      this.setState({ delete_dialog_open: false, delete_dialog_spin: false })
    }).catch(e => {
      /////console.log(e)
      this.notifySomething(e, "error")
      this.setState({ delete_dialog_open: false, delete_dialog_spin: false })
    })
  }
  
  notifySomething(message, type="success") {
    notify({
      message: message,
      position: {
        my: 'center top',
        at: 'center top',
      },
    }, type, 3000)
  }
  render() {
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />    
    if (this.state.dataLoading) return <LoadingSpinner />
    // aspettiamo che ci sia questa info prima di caricare il resto, altrimenti non mi aggiorna il filtro dei reseller
    if (!this.state.table_total_row_count_ready) return <LoadingSpinner />

    // ***

    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <Paper>

        {this.props.authStatus.user.is_admin && <>
          <ComputerListAddNewFormDialog
            open={this.state.add_new_dialog_open}
            spin={this.state.add_new_dialog_spin}
            onClickClose={this.handleComputerListAddNewFormDialog_ClickClose.bind(this)}
            onClickSubmit={this.handleComputerListAddNewFormDialog_ClickSubmit.bind(this)}
            onResellerIdChanged={this.handleComputerListAddNewDialog_ResellerIdChanged.bind(this)}
            resellerId={this.state.currentResellerId}
            resellersRows={this.state.resellersRows}
            dataLoading={this.state.dataLoading} />
          <ComputerListDeleteFormDialog
            open={this.state.delete_dialog_open}
            spin={this.state.delete_dialog_spin}
            onClickClose={this.handleComputerListDeleteFormDialog_ClickClose.bind(this)} 
            onClickSubmit={this.handleComputerListDeleteFormDialog_ClickSubmit.bind(this)} />
        </> }

        <Grid 
          rows={this.state.tableRows}
          columns={this.table_props.getTableColumns(this.props.authStatus.user)}
          getRowId={row => row.id} >

          <RowNumTypeProvider for={[ "row_num" ]} availableFilterOperations={[ 'equal' ]} />
          <IsResellerTypeProvider 
            for={[ "u_is_reseller", "u_is_gas_specialist" ]} 
            availableFilterOperations={[
              'equal',
            ]} />
          <IsAdminTypeProvider 
            for={[ "u_is_admin" ]} 
            availableFilterOperations={[
              'equal',
            ]} />
          <UserTypeTypeProvider 
            for={[ "u_user_type" ]} 
            availableFilterOperations={[
              'equal',
            ]} />
          <SwNameTypeProvider for={[ 
              "l_sw_name",
            ]} />
          <SwVerTypeProvider for={[ 
              "l_sw_ver",
            ]} />
          <GeoTypeProvider 
            ipAddrField={"l_ip_addr"}
            geoField="l_geo" 
            for={[ "l_geo" ]} />
          <UserCodeTypeProvider for={[ 
              "user_code",
            ]} />
          <UsernameTypeProvider for={[ 
              "u_username",
            ]} />
          <ResellerUsernameTypeProvider 
            for={[ 
              "reseller_username"
            ]}
            user={this.props.authStatus.user}
            resellersRows={this.state.resellersRows}
            updateTableRows={() => this.getTableRows(this.state.requestedTableSkip, this.state.requestedTableTake)} />
          <DataTypeProvider  
            for={[ "lic_options" ]}
            formatterComponent={props => <LicOptionsFormatter {...{ 
                ...props, 
                user: this.props.authStatus.user,
                programList: this.state.programList,
                dataChanged: this.tableRowsChanged.bind(this),                
              }} />
            } />
          <DateTypeProvider for={[
              "insert_date",
              "lic_update",
              "l_date_insert",
            ]} />

          {/* ********************************************* */}
          {/* ********************************************* */}
          {/* ********************************************* */}

          <SortingState
            sorting={this.state.tableSorting}
            onSortingChange={value => this.setState({ tableSorting: value })}
            columnExtensions={this.table_props.getTableSortingStateColumnExtensions()} />
          <VirtualTableState 
            loading={this.state.tableLoading}
            totalRowCount={this.state.tableTotalRowCount} 
            pageSize={VIRTUAL_PAGE_SIZE}
            skip={this.state.tableSkip}
            getRows={this.debouncedGetTableRows} />
          <FilteringState
            filters={this.state.tableFilters}
            onFiltersChange={this.setTableFilters.bind(this)}
            columnExtensions={this.table_props.getTableFilteringStateColumnExtensions()} />
          <VirtualTable 
            height={height}
            columnExtensions={this.table_props.getTableColumnExtensions()} />
          <TableColumnResizing
            columnWidths={this.state.tableColumnWidths}
            onColumnWidthsChange={value => this.setState({ tableColumnWidths: value })} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow showFilterSelector />
        </Grid>

        {this.props.authStatus.user.is_admin && <Box
          sx={{
            '& > :not(style)': { m: 1 },
            position: "fixed",
            bottom: (theme) => theme.spacing(3),
            right: (theme) => theme.spacing(5),            
          }} >
          <Fab color="primary" aria-label="add" onClick={() => this.setState({ add_new_dialog_open: true })} ><AddBoxIcon /></Fab>
          <Fab color="secondary" aria-label="delete" onClick={() => this.setState({ delete_dialog_open: true })} ><DeleteForeverIcon /></Fab>
        </Box>}
        
      </Paper>
    )
  }
}
